import './Default.css';

function DefaultPlaceholder({onClick, children}) {
  return(
    <div className="placeholder-container" onClick={onClick}>
      { children }
    </div>
  );
}

export default DefaultPlaceholder;